/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTextColor: {
  name: 'text-color';
  data: string;
} = {
  name: 'text-color',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 .5a.5.5 0 0 1 .447.276l3.996 7.991a.435.435 0 0 1 .01.02l.994 1.99a.5.5 0 1 1-.894.447L11.69 9.5H4.309l-.862 1.724a.5.5 0 1 1-.894-.448l.995-1.99a.492.492 0 0 1 .01-.019L7.552.777A.5.5 0 0 1 8 .5Zm-3.191 8h6.382L8 2.118 4.809 8.5ZM1.5 15a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5Z" fill="currentColor"/></svg>`,
};
